import {
  EditOutlined,
  StopOutlined,
  CheckOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Button, Space, Tooltip } from "antd";
import { useIntl } from "react-intl";
import { activityTypes } from "../../constants";

const ACTION_TYPES = {
  complete: {
    condition: (props) =>
      props.show_complete_button &&
      props.record?.task?.type !== activityTypes.ACTIVITIES_TYPE_MAIL,
    title: "app.activities.complete_task",
    icon: <CheckOutlined />,
    onClick: (record, callback) => callback(record),
  },
  edit: {
    condition: (props) =>
      props.record?.task?.type !== activityTypes.ACTIVITIES_TYPE_MAIL,
    title: "app.activities.edit_activity",
    icon: <EditOutlined />,
    onClick: (record, callback) => callback(record),
  },
  cancel: {
    condition: (props) => props.show_cancel_button,
    title: "app.activities.cancel_activity",
    icon: <StopOutlined style={{ color: "red" }} />,
    onClick: (record, callback) => callback(record),
  },
  delete: {
    condition: (props) => props.show_delete_button,
    title: "app.activities.delete_activity",
    icon: <DeleteOutlined style={{ color: "red" }} />,
    onClick: (record, callback) => callback(record),
  },
};

const Actions = (props) => {
  const {
    record,
    onCompleteTask,
    onCancelActivity,
    onEditActivity,
    onDeleteActivity,
  } = props;
  const intl = useIntl();

  const callbackMap = {
    complete: onCompleteTask,
    edit: onEditActivity,
    cancel: onCancelActivity,
    delete: onDeleteActivity,
  };
  return (
    <div>
      <Space.Compact block size="small">
        {Object.entries(ACTION_TYPES).map(([actionKey, actionValue]) => {
          if (!actionValue.condition || actionValue.condition(props)) {
            return (
              <Tooltip
                key={actionKey}
                title={intl.formatMessage({
                  id: actionValue.title,
                })}
              >
                <Button
                  icon={actionValue.icon}
                  onClick={() =>
                    actionValue.onClick(record, callbackMap[actionKey])
                  }
                />
              </Tooltip>
            );
          }
          return null;
        })}
      </Space.Compact>
    </div>
  );
};

export default Actions;
